import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/form-control';
import { Input, InputProps } from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';

interface IControlInput extends InputProps {
  error: boolean;
  label: string;
  name: string;
  messageError: string;
  // required?: boolean;
}

export const InputComponentChackra: ForwardRefRenderFunction<HTMLInputElement, IControlInput> = (
  {
    error,
    label,
    name,
    messageError,
    // required,
    ...rest
  },
  ref,
) => {
  return (
    <FormControl isInvalid={error}>
      <FormLabel fontSize="0.875rem" color="black" fontWeight="700" mb="0.2rem">
        {label}
      </FormLabel>
      <Input name={name} id={name} ref={ref} placeholder="Digite aqui" {...rest} />
      {error && <FormErrorMessage fontSize="0.8rem">{messageError}</FormErrorMessage>}
    </FormControl>
  );
};

export const InputComponent = forwardRef(InputComponentChackra);
